import {
  Admin as RaAdmin,
  CustomRoutes,
  type TranslationMessages,
  resolveBrowserLocale
} from 'react-admin'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { Route } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'
import { ja } from './translations-ja'
import { Layout } from 'components/Layout'
import { otherTheme } from 'components/Theme'
import Categories from 'components/Category'
import Contents from 'components/Contents'
import Content from 'components/Content'

log.setLevel(log.levels.DEBUG)

const translations: Record<string, TranslationMessages> = { ja }
const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] as TranslationMessages,
  resolveBrowserLocale(),
  [{ locale: 'ja', name: '日本語' }]
)
export const Admin: React.FC = () => {
  return (
    <RaAdmin
      i18nProvider={i18nProvider}
      requireAuth
      layout={Layout}
      lightTheme={otherTheme}
      darkTheme={otherTheme}>
      <CustomRoutes>
        <Route path="/" element={<Categories />} />
        <Route path="/:category" element={<Contents />} />
        <Route path="/:category/:content" element={<Content />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
